var _polygon, _polygon2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedtradeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.88mm",
    height: "10.93mm",
    viewBox: "0 0 36.5 30.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "36.5 .01 25.25 0 19.6 0 17.6 0 11.95 0 11.21 0 3.56 0 9.21 5.65 16.86 5.65 17.6 5.65 22.51 5.65 25.25 5.65 25.25 11.3 25.25 21.68 25.26 21.68 30.9 27.31 30.9 23.06 30.9 23.05 30.9 11.3 30.9 5.66 36.5 .01",
    fill: "currentColor"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "23.03 25.33 14.04 25.33 13.3 25.33 5.65 25.33 5.65 19.68 5.65 7.91 5.63 7.91 0 2.28 0 7.91 0 7.93 0 19.68 0 25.33 5.65 30.98 11.3 30.98 13.3 30.98 18.94 30.98 19.69 30.98 28.68 30.98 23.03 25.33",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 16.59,
    width: 3.38,
    height: 6.08,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.76,
    y: 10.63,
    width: 3.38,
    height: 12.04,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.22,
    y: 13.55,
    width: 3.38,
    height: 9.13,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedtradeIco);
export default __webpack_public_path__ + "static/media/lockedtrade-ico.6e2d3d70968f0072c92d7c54c8148671.svg";
export { ForwardRef as ReactComponent };